import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import React from 'react';
import styled from 'styled-components';

const StyledUnavailableMessage = styled.span`
  ${(props) => props.theme.fonts.mixins.header5}
  color: ${(props) => props.theme.colors.darkGray};
`;

interface INoPermissionsErrorMessageProps {
  hasPermissions?: boolean;
}

const NoPermissionsErrorMessage: React.FC<INoPermissionsErrorMessageProps> = ({ hasPermissions }) => {
  return (
    <StyledUnavailableMessage hidden={hasPermissions === undefined || hasPermissions}>
      <FontAwesomeIcon icon={faExclamationTriangle} /> You do not have the necessary permissions to edit this
    </StyledUnavailableMessage>
  );
};

export default NoPermissionsErrorMessage;
